











































































import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import { fieldType } from '../constant';
import ParamsServices, { ParamsDto } from '@/services/params';
import { Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { checkCode } from '@/libs/util';

@Component
export default class ParamsForm extends mixins(BaseFormMixin) {
  param = new ParamsServices();
  breadList = [{ name: '创建参数' }];

  formData: ParamsDto = {};
  tags = [];
  fieldType = fieldType;
  id: any = 0;
  categoryId: any = 0;
  keepalive: boolean = true;

  created() {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
  }

  activated() {
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    let path = this.$route.path;
    if (path == '/decision/params/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;
      this.formData = {};
      let categories = await this.param.getCategory();
      let category = categories.filter((category: any) => category.id == this.categoryId)[0];
      this.breadList = [{ name: category.label }, { name: '创建参数' }];
    } else if (path == '/decision/params/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      this.formData = await this.param.getInfo(this.id);
      this.spinning = false;
      this.current = 0;
      this.breadList = [{ name: this.formData.paramCategoryName || '' }, { name: this.formData.paramName || '' }, { name: '编辑参数' }];
    }
  }

  changeParamKind(e: string) {
    // this.formData.paramValue = '';
  }

  loading: boolean = false;
  async confirm() {
    const must: { field: 'paramCode' | 'paramName' | 'paramCategory' | 'paramKind'; msessage: string }[] = [
      { field: 'paramCode', msessage: '参数编码不能为空' },
      { field: 'paramName', msessage: '参数名称不能为空' },
      { field: 'paramCategory', msessage: '参数分类不能为空' },
      { field: 'paramKind', msessage: '参数类型不能为空' }
    ];
    for (let val of must) {
      if (!this.formData[val.field]) {
        this.$message.error(val.msessage);
        return false;
      }
    }
    if (!checkCode(this.formData.paramCode)) {
      this.$message.error('编码只能包含英文字母、数字、下划线');
      return false;
    }
    if (!this.id) {
      let code = 'PRM_' + this.formData.paramCode;
      let exist = await this.param.getList({ paramCode_eq: code });
      if (exist.length > 0) {
        this.$message.error(`编码[${code}]已经存在`);
        return false;
      }
    }
    this.loading = true;
    if (this.id) {
      let res = await this.param.update(this.formData);
      if (res) {
        this.replaceUrlWithOutConfirm('/decision/params/detail?id=' + this.id);
        this.formData = {};
      }
    } else {
      let categoryId: number | boolean = typeof this.$route.query.categoryId === 'string' ? parseInt(this.$route.query.categoryId) : false;
      if (!categoryId) {
        this.$message.error('参数错误：没有指定目录');
        return false;
      }
      this.formData.paramCategoryId = categoryId;
      let res = await this.param.add(this.formData);
      if (res) {
        this.formData = {};
        this.replaceUrlWithOutConfirm('/decision/params/detail?id=' + res.id);
      }
    }
    this.loading = false;
    this.HANDLE_RELOAD_PARAM_MENU();
  }
  @Mutation HANDLE_RELOAD_PARAM_MENU: any;
}
